<template>
  <v-container class="ngl_container">
    <v-row class="ngl-img" justify="center" no-gutters>
      <v-col cols="8" class="d-flex flex-column">
        <div class="ngl-title">
          <div>
            <h5 class="mt-3 mb-1 ml-1">
              <v-icon small class="icon">
                mdi-transit-connection-variant </v-icon
              >PROJECT NAME :
              <span class="name"> {{ current_project.project_name }}</span>
              {{ current_project.ligands.length }} ligands
            </h5>
          </div>
        </div>
        <ngl />
      </v-col>
      <v-col cols="4" class="d-flex sidebar">
        <sidebar />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";
import ngl from "@/components/NGLViewport.vue";
import sidebar from "@/components/Sidebar.vue";

export default {
  project_name: "Detail",
  components: {
    ngl,
    sidebar,
  },
  props: {
    item: {
      type: Object,
      default: () => ({ project_name: "SilcBIO DEMO" }),
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapState(["current_project"]),
  },
  // initialize
  beforeRouteLeave(to, from, next) {
    this.$store.commit("initialize");
    next();
  },
  methods: {
    // ...mapActions([
    //   'uploadLigands',
    // ]),
    new_project: function () {
      this.newproject = !this.newproject;
    },

    initializeStage() {
      // console.log("TEST => [Detail.vue/initializeStage]: start");

      let opts = { id: "viewport" };
      this.$store.dispatch("createNewDetailStage", opts);

      // console.log("TEST => [Detail.vue/initializeStage]: end");
    },
  },

  mounted() {
    // Note:
    // To initialize the stage
    this.initializeStage();
  },
};
</script>

<style>
/* .fill-height {
  position: relative;
  height: 100%;
} */
.ngl_container {
  height: calc(100vh - 82px);

  display: flex;
  flex-direction: column;
}
.ngl_container .ngl-title {
  height: calc(100vh - 82px);
  flex: 0 0 48px;
}
.ngl_container .ngl-img {
  flex: 1;
}
canvas {
  border-radius: 30px;
  border: 10px solid #e1effb;
}
.name {
  color: #42a5f6 !important;
  font-size: 1.5em;
  background: #eaf3fb !important;
  border-radius: 10px;
  padding: 4px 12px;
}
.sidebar {
  /* min-width: 300px; */
}
</style>
